<div *ngFor="let mi of moreItems || []" class="elStyle" (click)="moreItemClicked(mi, $event)">
    <ion-icon [name]="mi.icon" class="iconStyle" [color]="mi.iconColor"></ion-icon>
</div>
<div *ngIf="items" class="elStyle" (click)="buttonClicked($event)">
    <ion-icon name="ellipsis-vertical" class="iconStyle"></ion-icon>
</div>